import { Outlet, useNavigate } from "react-router-dom";
import './../../assets/styles/fintech.css'
import { useAppDispatch } from "../../hooks/hooks";
import { settings } from "../../redux/settings/actions";
import { useSelector } from "react-redux";
import { selectCurrent } from "../../redux/settings/selectors";
import { useEffect, useState } from "react";
import ThemeProvider from "../../hooks/themeProvider";
import Settings from "../../components/partner/Settings";
import Header from "../../components/partner/Header";
import Sidebar from "../../components/partner/Sidebar";
import Footer from "../../components/partner/Footer";



const PartnerLayout = () => {
    let navigate = useNavigate()
    const dispatch = useAppDispatch()
    const [color, setColor] = useState('universal')
    const handleSettigns = () => {
        dispatch(settings.set({ visible: !visible }))
    }
    const [isLoading, setIsLoading] = useState(false)
    const result = useSelector(selectCurrent)
    const { header, footer, visible, sidebar, theme } = result
    useEffect(() => {
        dispatch(settings.set({ theme: 'universal' }))
    }, [])

    useEffect(() => {
        setColor(theme)
        if (theme == 'darkmode') {
            dispatch(settings.set({ primary: '#f5e93cac' }))
            dispatch(settings.set({ secondary: '#ffffff' }))

        }
        else if (theme == 'lightmode') {
            dispatch(settings.set({ primary: '#ffffffa2' }))
            dispatch(settings.set({ secondary: '#000000a2' }))
        }
        else if (theme == 'universal') {
            dispatch(settings.set({ primary: '#233C64' }))
            dispatch(settings.set({ secondary: '#ffffff' }))
        }
        else if (theme == 'luxury') {
            dispatch(settings.set({ primary: '#bd238c' }))
            dispatch(settings.set({ secondary: '#ffffff' }))

        }
        else if (theme == 'harmony') {
            dispatch(settings.set({ primary: '#000000a2' }))
            dispatch(settings.set({ secondary: '#000000a2' }))
        }
        else if (theme == 'warmth') {
            dispatch(settings.set({ primary: '#000000a2' }))

        }
        // const data = document.getElementById("layer") as HTMLInputElement;
        // data.setAttribute("fill", "#603812")
        // data.setAttribute("stroke", "#603812")
    }, [theme]);

    return (
        <>
            <ThemeProvider>
                <div className="leading-normal tracking-normal" id="main-body">
                    <div className="flex flex-col w-full sm:hide max-h-screen h-screen bg-slate-200">
                        {visible ? <Settings /> : <></>}
                        <Header />
                        <div className="w-full flex flex-row bg-primary">
                            <Sidebar />
                            <div className={`z-0 ${sidebar ? `ml-64` : `ml-24`} w-full overflow-auto  bg-slate-200 dark:bg-slate-300`}>
                                <Outlet />
                            </div>
                        </div>
                        <div className="fixed w-full bottom-0 z-[1000] bg-slate-50">
                            {footer ? <Footer /> : ""}
                        </div>
                    </div>
                </div>
            </ThemeProvider>
        </>
    )
}
export default PartnerLayout;